import {createContext, useContext} from 'react';

interface SlugResolution {
    presentationId: string;
    params: {[key: string]: string};
}

const SlugResolutionContext = createContext<SlugResolution | null>(null);

export const useSlugResolution = (): SlugResolution | null => useContext(SlugResolutionContext);

export default SlugResolutionContext;
